import { promptPasswordWithSaveOption } from "@/hooks/walletDialogs";
import { MetroSwal } from "@/utils";
import CryptoJS from "crypto-js";
import { ethers } from "ethers";
import { config } from "@/utils/config";
import { saveEncryptedSeed, setSeedBackupDone, setSavedPasswordPreference, getEncryptedSeed } from "@/localstorage/walletStorage";

const SALT = config.TG_SECRET_SALT || "default_salt";

export const importWalletFlow = async (
  mnemonic: string,
  identifier: string | null,
  onImported?: (password: string) => void,
  providedPassword?: string,
  providedSavePassword?: boolean
): Promise<string | null> => {
  
  if (!ethers.utils.isValidMnemonic(mnemonic)) {
    console.error("Invalid mnemonic"); 
    await MetroSwal.fire("Invalid Phrase", "Please check your 12‑word seed phrase.", "error");
    return null;
  }
  
  let password: string;
  let savePassword: boolean;
  

  if (providedPassword) {
    password = providedPassword;
    savePassword = providedSavePassword || false;
  } else {

    const { isConfirmed, value: dialogPassword, savePassword: dialogSavePassword } = await promptPasswordWithSaveOption();
    
    if (!isConfirmed || !dialogPassword) return null;
    
    password = dialogPassword;
    savePassword = dialogSavePassword;
  }

  const fullKey = password + "|" + SALT;
  const encrypted = CryptoJS.AES.encrypt(mnemonic, fullKey).toString();

  saveEncryptedSeed(identifier || "", encrypted);
  setSeedBackupDone(identifier || "", true);
  setSavedPasswordPreference(savePassword);
  
  const savedEncrypted = getEncryptedSeed(identifier || "");
  console.log("Verification - Data saved to localStorage:", savedEncrypted ? "Success" : "Failed");

  if (onImported) {
    onImported(password);
    // Skip showing alert if callback is provided
  } else {
    console.log('"Wallet Imported!", "Your wallet has been securely saved.", "success"');
    //await MetroSwal.fire("Wallet Imported!", "Your wallet has been securely saved.", "success");
  }
  
  return password;
};
